module.exports = __webpack_public_path__ + "static/media/case-meeting-rooms.bc7af4c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-meeting-rooms.jpg
// module id = 81
// module chunks = 3